import { ProfessionalCard } from '@components/Consultation/components/ProfessionalCard'

import { getSlugTranslation } from '@/locale/utils'

export const VideoCallEnded = () => {
  return (
    <div className="flex flex-1 flex-col items-center gap-4 p-4" data-testid="ending-container">
      <ProfessionalCard
        footer={
          <p className="text-gray-text w-full rounded-lg bg-gray-100 p-2 text-center text-sm whitespace-break-spaces">
            {getSlugTranslation('general.consultation.videoConsultation.summary_waiting_time')}
          </p>
        }
      >
        <p className="text-center">{getSlugTranslation('general.consultation.videoConsultation.isPreparingSummary')}</p>
      </ProfessionalCard>
    </div>
  )
}
